(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  const closeLanguageDropdowns = (restoreFocus = false) => {
    document.querySelectorAll('[data-language-disclosure].is-open').forEach((disclosure) => {
      disclosure.classList.remove('is-open');
      const toggle = disclosure.querySelector('[data-language-toggle]');
      const menu = disclosure.querySelector('[data-language-menu]');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        if (restoreFocus) toggle.focus();
      }
      if (menu) menu.hidden = true;
    });
  };

  const closeMobileMenu = (restoreFocus = false) => {
    document.querySelectorAll('[data-mobile-toggle][aria-expanded="true"]').forEach((toggle) => {
      toggle.setAttribute('aria-expanded', 'false');
      const menuId = toggle.getAttribute('aria-controls');
      const menu = menuId ? document.getElementById(menuId) : null;
      if (menu) menu.hidden = true;
      if (restoreFocus) toggle.focus();
    });
    document.documentElement.classList.remove('mobile-menu-open');
  };

  const closeHeaderDropdowns = (restoreFocus = false) => {
    document.querySelectorAll('[data-header-dropdown].is-open').forEach((dropdown) => {
      dropdown.classList.remove('is-open');
      const toggle = dropdown.querySelector('[data-dropdown-toggle]');
      if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
        if (restoreFocus) toggle.focus();
      }
    });
  };

  document.addEventListener('click', (event) => {
    const languageOption = event.target.closest('[data-language-option]');
    if (languageOption) {
      const form = languageOption.closest('form');
      const input = form && form.querySelector('[data-language-input]');
      if (form && input) {
        input.value = languageOption.dataset.languageValue;
        const isLocalPreview = window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost';
        if (isLocalPreview) {
          const currentRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
          const currentPrefix = currentRoot === '/' ? '' : currentRoot.replace(/\/$/, '');
          let relativePath = window.location.pathname.replace(/^\/+/, '');

          if (currentPrefix && (window.location.pathname === currentPrefix || window.location.pathname.startsWith(`${currentPrefix}/`))) {
            relativePath = window.location.pathname.slice(currentPrefix.length).replace(/^\/+/, '');
          }

          const targetRoot = languageOption.dataset.languageRoot || '/';
          window.location.assign(`${targetRoot}${relativePath}${window.location.search}${window.location.hash}`);
        } else {
          form.submit();
        }
      }
      return;
    }

    const mobileToggle = event.target.closest('[data-mobile-toggle]');
    if (mobileToggle) {
      closeLanguageDropdowns();
      const menuId = mobileToggle.getAttribute('aria-controls');
      const menu = menuId ? document.getElementById(menuId) : null;
      const expanded = mobileToggle.getAttribute('aria-expanded') === 'true';
      mobileToggle.setAttribute('aria-expanded', String(!expanded));
      if (menu) menu.hidden = expanded;
      document.documentElement.classList.toggle('mobile-menu-open', !expanded);
    }

    const dropdownToggle = event.target.closest('[data-dropdown-toggle]');
    if (dropdownToggle) {
      closeLanguageDropdowns();
      const dropdown = dropdownToggle.closest('[data-header-dropdown]');
      const willOpen = dropdown && !dropdown.classList.contains('is-open');
      closeHeaderDropdowns();

      if (dropdown && willOpen) {
        dropdown.classList.add('is-open');
        dropdownToggle.setAttribute('aria-expanded', 'true');
      }
    } else if (!event.target.closest('[data-header-dropdown]')) {
      closeHeaderDropdowns();
    }

    const languageToggle = event.target.closest('[data-language-toggle]');
    if (languageToggle) {
      const disclosure = languageToggle.closest('[data-language-disclosure]');
      const menu = disclosure && disclosure.querySelector('[data-language-menu]');
      const willOpen = disclosure && !disclosure.classList.contains('is-open');
      closeLanguageDropdowns();

      if (disclosure && menu && willOpen) {
        disclosure.classList.add('is-open');
        languageToggle.setAttribute('aria-expanded', 'true');
        menu.hidden = false;
      }
    } else if (!event.target.closest('[data-language-disclosure]')) {
      closeLanguageDropdowns();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeHeaderDropdowns(true);
      closeLanguageDropdowns(true);
      closeMobileMenu(true);
    }
  });

  window.matchMedia('(min-width: 820px)').addEventListener('change', (event) => {
    if (event.matches) {
      closeLanguageDropdowns();
      closeMobileMenu();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const variantButton = event.target.closest('[data-variant-button]');
    if (variantButton) {
      const selector = variantButton.closest('[data-variant-selector]');
      const form = variantButton.closest('form');
      const variantInput = selector && selector.querySelector('[data-variant-input]');
      const productPage = variantButton.closest('.product-page');
      const price = productPage && productPage.querySelector('[data-product-price]');

      if (selector && variantInput) {
        selector.querySelectorAll('[data-variant-button]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button === variantButton));
        });
        variantInput.value = variantButton.dataset.variantId;
      }

      if (price && variantButton.dataset.variantPrice) {
        price.textContent = variantButton.dataset.variantPrice;
      }

      if (form) {
        const addButton = form.querySelector('button[name="add"]');
        if (addButton) addButton.disabled = false;
      }
    }

    const quantityButton = event.target.closest('[data-quantity-action]');
    if (quantityButton) {
      const wrapper = quantityButton.closest('[data-quantity]');
      const input = wrapper && wrapper.querySelector('input[name="quantity"]');
      if (input) {
        const step = quantityButton.dataset.quantityAction === 'increase' ? 1 : -1;
        input.value = Math.max(Number(input.min || 1), Number(input.value || 1) + step);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    const thumbnail = event.target.closest('[data-product-thumb]');
    if (thumbnail) {
      const gallery = thumbnail.closest('[data-product-gallery]');
      const featured = gallery && gallery.querySelector('[data-product-featured]');
      const image = thumbnail.querySelector('img');
      if (featured && image) {
        featured.src = thumbnail.dataset.fullSrc || image.src;
        featured.srcset = thumbnail.dataset.fullSrcset || '';
        featured.alt = image.alt || '';
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
